/* ==========================================================================
   AutocompleteRxjs > Template
   ========================================================================== */

/* Import modules */
const { html } = require('common-tags');

const ViewHelpers = require('@bluekiri/alexandria/core/ViewHelpers');
const { prepareDataConfig } = require('@bluekiri/alexandria/helpers/dataHelpers');
const { sanitizeSingleQuote } = require('../../helpers/sanitize');

const configuration = require('./client/js/config');
const { GEOLOCATION, LIMIT, THRESHOLD, PLACEMENT, APPENDTOPARENT, LOADER_TEMPLATE, MAX } = require('./constants');

const renderInput = data => {
    const { title, name, placeholder, isLoading } = data;

    const titleAttr = title ? `title='${title}'` : '';
    const nameAttr = name ? `name='${name}'` : '';
    const placeholderAttr = placeholder ? `placeholder='${placeholder}'` : '';
    const disableAttr = isLoading ? 'disabled' : '';

    return html(`<input type='search' autocomplete="off" ${titleAttr} ${nameAttr} ${placeholderAttr} ${disableAttr}>`);
};

/**
 * AutocompleteRxjs template
 * @param {object} data Object containing the data model for this component.
 * @param {object} context The general context object.
 * @returns {object} Additional data to have available in the template
 */
module.exports = function Template(data, context) {
    /* Data */
    const {
        config = {},
        label,
        icon,
        placeholder,
        value = false,
        geolocation = GEOLOCATION,
        limit = LIMIT,
        max = MAX,
        threshold = THRESHOLD,
        placement = PLACEMENT,
        appendToParent = APPENDTOPARENT,
        types = [],
        operator,
        codes,
        hidden = false,
        active = false,
        disabled = false,
        isLoading = false
    } = data;
    const { styles = [], literals = {}, isAlternative = false } = config;

    const { dataType } = prepareDataConfig(config.data);
    const dataTypeAttr = dataType ? html(`data-type="${dataType}"`) : html('');
    const configData = {
        ...config,
        context,
        literals,
        value,
        appendToParent,
        geolocation,
        limit,
        max,
        threshold,
        hasPlaceHolder: !!placeholder,
        placement,
        types,
        operator,
        codes,
        hidden,
        active,
        disabled,
        isLoading
    };
    const dataConfigAttr = html(`data-config='${sanitizeSingleQuote(JSON.stringify({ ...configData }))}'`);

    /* Css .clases */
    const cssClass = ''.concat(
        'input-rxjs ',
        'autocomplete-rxjs ',
        isAlternative ? `${configuration().css.alternative}` : '',
        placeholder && !isAlternative ? ` ${configuration().css.active}` : '',
        hidden ? ` ${configuration().css.hidden}` : '',
        active || (value && value !== null) ? ` ${configuration().css.active}` : '',
        disabled ? ` ${configuration().css.disabled}` : '',
        isLoading ? `${configuration().css.loading}` : '',
        ...styles.map(style => ` ${style}`)
    );

    /* Render elements */
    const renderLabel = label ? `<label>${label}</label>` : html('');
    const renderIcon = icon ? ViewHelpers(context).icon(icon) : html('');
    const loaderTemplate = isLoading ? LOADER_TEMPLATE : '';

    /* -Template */
    return html(`
        <div class='${cssClass}'
            data-component='${configuration().component}'
            ${dataTypeAttr}
            ${dataConfigAttr}>
            ${renderLabel}
            ${renderIcon}
            ${renderInput({ ...data, isAlternative, isLoading })}
            ${loaderTemplate}
        </div>
    `);
};
